export const blockIconsHardwareSmartphoneNew = (
	<span className='material-symbols-outlined'>smartphone</span>
);
